module.exports = __webpack_public_path__ + "static/generator-853c3bfce2877c3099746b905da3b33d.jpg";